import api from "./api";

/**
 * ============================================
 * GET RBAC
 * backend reads: req.query.roleId, req.query.enterprize_id
 * ============================================
 */
export const getRBACAPI = (roleId = "", enterprize_id = "") =>
  api.get("/rbac/my-rbac", {
    params: { roleId, enterprize_id },
  });

/**
 * ============================================
 * UPDATE PAGE PERMISSION
 * backend expects flat structure
 * ============================================
 */
export const updatePermissionAPI = (data) =>
  api.put("/rbac/update-permission", {
    role_id: data.role_id,
    page_id: data.page_id,
    enterprize_id: data.enterprize_id,
    can_view: data.can_view,
    can_create: data.can_create,
    can_edit: data.can_edit,
    can_delete: data.can_delete,
  });

/**
 * ============================================
 * SIDEBAR ORDER
 * ============================================
 */
export const getSidebarOrderAPI = () => api.get("/rbac/sidebar-order");

export const updateSidebarOrderAPI = (page_ids = []) =>
  api.put("/rbac/sidebar-order", { page_ids });
